/** * * Asynchronously loads the component for
Activation
* */ import { lazyLoad } from "utils/loadable";
export const Activation = lazyLoad(
  () => import("./index"),
  (module) => module.Activation
);
